module.exports = __webpack_public_path__ + "img/cast-icon.088eb268.svg";